<template>
  <div class="home">
    <div >
            <div>
                <section>
                    <div class="py-8 px-8">
                    <div class="d-flex flex-wrap align-items-center justify-content-between">
                        <div class="col-12 col-lg-auto mb-4 mb-lg-0">
                        <div class="d-flex align-items-center">
                            <h4 class="mb-0 me-2">{{$t('users')}}</h4>
                        </div>
                        </div>
                        <div class="col-12 col-lg-auto d-flex align-items-center">
                        <button @click="create" v-if="!business.affiliate_id" class="flex-shrink-0 btn btn-success d-flex align-items-center">
                            <span class="d-inline-block me-2 .text-primary-dark">
                            <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                            </span>
                            <span>{{$t('user')}}</span>
                        </button>
                        </div>
                    </div>
                    </div>
                </section>
            </div>
      
            <section class="py-8">
                <div class="px-8">
                <div class="page-table-container mb-6 bg-white rounded shadow">

                    <!-- table -->
                    <div class="table-responsive">
                        <table class="table mb-0 table-borderless table-striped small">
                            <thead>
                                <tr class="text-secondary">
                                    <sortable-table-header field="id" label="user_id" :sort-field="sortField" :sort-direction="sortDirection" @sort="sortUsers" />
                                    <sortable-table-header field="name" label="name" :sort-field="sortField" :sort-direction="sortDirection" @sort="sortUsers" />
                                    <sortable-table-header field="email" label="email" :sort-field="sortField" :sort-direction="sortDirection" @sort="sortUsers" />
                                    <th class="pt-4 pb-3 px-6">{{$t('role')}}</th>
                                    <th class="pt-4 pb-3 px-6">{{$t('modules')}}</th>
                                    <sortable-table-header field="created_at" label="created_at" :sort-field="sortField" :sort-direction="sortDirection" @sort="sortUsers" />
                                    <th class="pt-4 pb-3 px-6">{{$t('action')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr v-for="user in users" :key="user.id">
                                <td class="py-5 px-6"><router-link :to="`/users/${user.id}`">{{shortId(user.id)}}</router-link></td>
                                <td class="py-5 px-6">{{user.name}}</td>
                                <td class="py-5 px-6">{{user.email}}</td>
                                <td class="py-5 px-6">{{user.UserBusiness.role}}</td>
                                <td class="py-5 px-6">
                                    <div class="user-module-badges">
                                        <span
                                            v-if="isOwnerUser(user)"
                                            class="badge user-module-badge"
                                        >
                                            {{$t('all_modules')}}
                                        </span>
                                        <span
                                            v-else
                                            v-for="module in getVisibleUserModules(user)"
                                            :key="module.module_key || module.id"
                                            class="badge user-module-badge"
                                        >
                                            {{$t(module.title)}}
                                        </span>
                                        <span
                                            v-if="!isOwnerUser(user) && hasHiddenUserModules(user)"
                                            class="badge user-module-badge user-module-more"
                                        >
                                            ...
                                        </span>
                                        <span v-if="!isOwnerUser(user) && !getUserModules(user).length" class="text-muted">-</span>
                                    </div>
                                </td>
                                <td class="py-5 px-6">{{formatDate(user.created_at)}}</td>
                                <td class="py-5 px-6">
                                    <div class="user-row-actions">
                                        <button @click="edit(user)" class="btn btn-primary btn-xs user-row-action">
                                            <AppIcon name="bi-pencil" class="bi bi-pencil" style="font-size:12px" />
                                            {{$t('edit')}}
                                        </button>
                                        <button :disabled="user.UserBusiness.role == 'owner'" @click="deleteRow(user)" class="btn btn-primary btn-xs user-row-action">
                                            <AppIcon name="bi-trash" class="bi bi-trash" style="font-size:12px" />
                                            {{$t('delete')}}
                                        </button>
                                    </div>
                                </td>
                            </tr>

                            </tbody>
                        </table>

                        <div v-if="count > users.length" style="text-align:center;margin-top:1rem;margin-bottom:1rem">
                            <button @click="getUsers(true)" class="btn p-0" type="button">{{$t('load_more')}}</button>
                        </div>
                    </div>
                    <!-- table -->
                    <table-loading-bar v-if="loading" class="page-table-state text-center" />
                    <div v-if="loading === false && !users.length" class="page-table-state text-center" style="padding:1rem">{{$t('no_users_found')}}.</div>

                </div>

                </div>
            </section>
      </div>

        <!-- create Modal -->
        <div class="modal fade" id="user-create-modal" tabindex="-1" aria-labelledby="user-create-modal" aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{$t('create_user')}}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                </div>
                <div class="modal-body" style="text-align:left">
                    <div class="row">
                        <div class="col-sm-3 mb-3">
                            <label for="exampleFormControlInput1" class="form-label">{{$t('name')}}</label>
                            <input v-model="user.name" type="string"  class="form-control" id="exampleFormControlInput1" placeholder="Name">
                        </div>
                        <div class="col-sm-5 mb-3">
                            <label for="exampleFormControlInput1" class="form-label">{{$t('email')}}</label>
                            <input v-model="user.email" type="email" class="form-control" id="exampleFormControlInput1" placeholder="Email">
                        </div>
                        <div class="col-sm-4 mb-3">
                            <label for="exampleFormControlInput1" class="form-label">{{$t('password')}}</label>
                            <div class="input-group">
                                <input v-model="user.password" :type="showPassword ? 'text' : 'password'" class="form-control" id="exampleFormControlInput1" placeholder="********">
                                <button class="btn btn-outline-secondary" type="button" @click="showPassword = !showPassword">
                                    <AppIcon :name="showPassword ? 'bi-eye-slash' : 'bi-eye'" class="bi" :class="showPassword ? 'bi-eye-slash' : 'bi-eye'" />
                                </button>
                            </div>
                        </div>
                        <div class="col-12 mb-3">
                            <label class="form-label">{{$t('access')}}</label>
                            <div class="d-flex justify-content-between align-items-center bg-light p-3 rounded border">
                                <div>
                                    <div class="fw-bold mb-1">{{ user.role === 'admin' ? $t('admin_access') : $t('limited_access') }}</div>
                                    <div class="text-muted small">
                                        {{ user.role === 'admin' ? $t('admin_access_description') : $t('limited_access_description') }}
                                    </div>
                                </div>
                                <div class="form-check form-switch ms-3 mb-0">
                                    <input 
                                        v-model="user.role" 
                                        class="form-check-input" 
                                        type="checkbox" 
                                        role="switch" 
                                        id="role_toggle_create" 
                                        true-value="admin" 
                                        false-value="staff"
                                        style="width: 2.8rem; height: 1.4rem; cursor: pointer;"
                                    >
                                </div>
                            </div>
                        </div>
                      
                        <div class="mb-3" v-if="user.role != 'owner'">
                                <label for="exampleFormControlInput1" class="form-label fw-bold  mb-3">
                                    <AppIcon name="bi-shield-lock-fill" class="bi bi-shield-lock-fill me-2" />{{$t('permissions')}}
                                </label>

                                <div class="row g-3">
                                    <div
                                        v-for="module in filteredPermissionsModules"
                                        :key="module.id"
                                        class="col-sm-6 col-lg-4"
                                    >
                                    <div class="card border-0 shadow-sm h-100 hover-shadow">
                                        <div class="card-header bg-primary text-white py-3 d-flex align-items-center justify-content-between">
                                            <div class="d-flex align-items-center">
                                                <AppIcon :name="module.icon || 'bi bi-folder'" :class="module.icon || 'bi bi-folder'" class="text-white me-2" style="font-size: 1.2rem;" />
                                                <h6 class="mb-0 text-white">{{$t(module.title)}}</h6>
                                            </div>
                                            <button 
                                                type="button" 
                                                class="btn btn-sm btn-light btn-toggle-module" 
                                                @click="toggleModulePermissions(module)"
                                                :title="$t('toggle_all')"
                                            >
                                                <AppIcon name="bi-check2-square" class="bi bi-check2-square" />
                                            </button>
                                        </div>
                                        <div class="card-body p-3">
                                            <div
                                                v-for="item in module.items"
                                                :key="Object.keys(item)[0]"
                                                class="mb-3"
                                            >
                                                <div class="d-flex align-items-center mb-2 pb-2 border-bottom">
                                                    <div class="form-check form-switch mb-0">
                                                        <input 
                                                            class="form-check-input" 
                                                            type="checkbox" 
                                                            :id="`manage-${Object.keys(item)[0]}`"
                                                            :checked="isSubModuleManaged(Object.values(item)[0])"
                                                            @change="toggleManageSubModule(Object.values(item)[0], $event)"
                                                        />
                                                        <label class="form-check-label text-dark fw-semibold small" :for="`manage-${Object.keys(item)[0]}`" style="cursor: pointer;margin-top:2px">
                                                            {{$t('manage')}} {{$t(Object.keys(item)[0])}}
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="ps-3" v-if="isSubModuleManaged(Object.values(item)[0])">
                                                    <div
                                                        v-for="permission in Object.values(item)[0].permissions"
                                                        :key="permission.key"
                                                        class="form-check mb-2"
                                                    >
                                                        <input
                                                            v-model="permissionsState[permission.key]"
                                                            class="form-check-input"
                                                            type="checkbox"
                                                            :id="`create-${permission.key}`"
                                                        />
                                                        <label class="form-check-label small" :for="`create-${permission.key}`">
                                                            {{$t(permission.label)}}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                    <button type="button" class="btn btn-success" :disabled="loading || user.name.length < 2 || user.email.length < 9 || (user.password && user.password.length < 4)" @click="save"><AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />{{$t('create')}}</button>
                </div>
                </div>
            </div>
        </div>
        <!-- create modal -->


        <!-- Edit Modal -->
        <div class="modal fade" id="user-edit-modal" tabindex="-1" aria-labelledby="user-edit-modal" aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{$t('edit_user')}}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                </div>
                <div class="modal-body" style="text-align:left">
                    <div class="row">
                        <div class="col-sm-6 mb-3">
                            <label for="exampleFormControlInput1" class="form-label">{{$t('name')}}</label>
                            <input v-model="user.name" type="string"  class="form-control" id="exampleFormControlInput1" placeholder="Name">
                        </div>
                        <div class="col-sm-6 mb-3">
                            <label for="exampleFormControlInput1" class="form-label">{{$t('email')}}</label>
                            <input v-model="user.email" type="email" class="form-control" id="exampleFormControlInput1" placeholder="Email">
                        </div>
                        <div class="col-12 mb-3">
                            <label for="exampleFormControlInput1" class="form-label">{{$t('password')}}</label>
                            <div class="input-group">
                                <input v-model="user.password" :type="showPassword ? 'text' : 'password'" class="form-control" id="exampleFormControlInput1" placeholder="********">
                                <button class="btn btn-outline-secondary" type="button" @click="showPassword = !showPassword">
                                    <AppIcon :name="showPassword ? 'bi-eye-slash' : 'bi-eye'" class="bi" :class="showPassword ? 'bi-eye-slash' : 'bi-eye'" />
                                </button>
                            </div>
                        </div>
                        <div class="col-12 mb-3" v-if="user.role != 'owner'">
                            <label class="form-label">{{$t('access')}}</label>
                            <div class="d-flex justify-content-between align-items-center bg-light p-3 rounded border">
                                <div>
                                    <div class="fw-bold mb-1">{{ user.role === 'admin' ? $t('admin_access') : $t('limited_access') }}</div>
                                    <div class="text-muted small">
                                        {{ user.role === 'admin' ? $t('admin_access_description') : $t('limited_access_description') }}
                                    </div>
                                </div>
                                <div class="form-check form-switch ms-3 mb-0">
                                    <input 
                                        v-model="user.role" 
                                        class="form-check-input" 
                                        type="checkbox" 
                                        role="switch" 
                                        id="role_toggle_edit" 
                                        true-value="admin" 
                                        false-value="staff"
                                        style="width: 2.8rem; height: 1.4rem; cursor: pointer;"
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="mb-3" v-if="user.role != 'owner'">
                                <label for="exampleFormControlInput1" class="form-label fw-bold text-primary mb-3">
                                    <AppIcon name="bi-shield-lock-fill" class="bi bi-shield-lock-fill me-2" />{{$t('permissions')}}
                                </label>

                                <div class="row g-3">
                                    <div
                                        v-for="module in filteredPermissionsModules"
                                        :key="module.id"
                                        class="col-sm-6 col-lg-4"
                                    >
                                    <div class="card border-0 shadow-sm h-100 hover-shadow">
                                        <div class="card-header bg-primary text-white py-3 d-flex align-items-center justify-content-between">
                                            <div class="d-flex align-items-center">
                                                <AppIcon :name="module.icon || 'bi bi-folder'" :class="module.icon || 'bi bi-folder'" class="text-white me-2" style="font-size: 1.2rem;" />
                                                <h6 class="mb-0 text-white">{{$t(module.title)}}</h6>
                                            </div>
                                            <button 
                                                type="button" 
                                                class="btn btn-sm btn-light btn-toggle-module" 
                                                @click="toggleModulePermissions(module)"
                                                :title="$t('toggle_all')"
                                            >
                                                <AppIcon name="bi-check2-square" class="bi bi-check2-square" />
                                            </button>
                                        </div>
                                        <div class="card-body p-3">
                                            <div
                                                v-for="item in module.items"
                                                :key="Object.keys(item)[0]"
                                                class="mb-3"
                                            >
                                                <div class="d-flex align-items-center mb-2 pb-2 border-bottom">
                                                    <div class="form-check form-switch mb-0">
                                                        <input 
                                                            class="form-check-input" 
                                                            type="checkbox" 
                                                            :id="`manage-edit-${Object.keys(item)[0]}`"
                                                            :checked="isSubModuleManaged(Object.values(item)[0])"
                                                            @change="toggleManageSubModule(Object.values(item)[0], $event)"
                                                        />
                                                        <label class="form-check-label text-dark fw-semibold small" :for="`manage-edit-${Object.keys(item)[0]}`" style="cursor: pointer;margin-top:2px">
                                                            {{$t('manage')}} {{$t(Object.keys(item)[0])}}
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="ps-3" v-if="isSubModuleManaged(Object.values(item)[0])">
                                                    <div
                                                        v-for="permission in Object.values(item)[0].permissions"
                                                        :key="permission.key"
                                                        class="form-check mb-2"
                                                    >
                                                        <input
                                                            v-model="permissionsState[permission.key]"
                                                            class="form-check-input"
                                                            type="checkbox"
                                                            :id="`edit-${permission.key}`"
                                                        />
                                                        <label class="form-check-label small" :for="`edit-${permission.key}`">
                                                            {{$t(permission.label)}}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                    <button type="button" class="btn btn-success" :disabled="loading || (user.name && user.name.length < 2) || (user.email && user.email.length < 9) || (user.password && user.password.length < 4)" @click="update"> <AppIcon name="bi-pencil" class="bi bi-pencil me-2" style="font-size:12px" />{{$t('edit')}}</button>
                </div>
                </div>
            </div>
        </div>
        <!-- Edit modal -->

  </div>
</template>

<script>
import helper from '../../helper'
import sortableList from '../../mixins/sortableList'
export default {
  name: 'User',
  persistedFilterState: { key: 'users', fields: ['sortField', 'sortDirection'] },
  mixins: [sortableList],
  data() {
    return {
      search : '',
      count : 0,
      users : [],
      user : {
          id : null,
          name : '',
          email : '',
          password : '',
          role : 'staff'
      },
      createModal : null,
      editModal : null,
      loading: false,
      showPassword: false,
      permissionsModules: [
        {
          id: 'dashboard',
          title: 'dashboard_title',
          icon: 'bi bi-speedometer2',
          color: '#6366f1',
          colorDark: '#4f46e5',
          items: [
            {
              dashboard: { 
                permissions: [
                  { key: 'view_dashboard', label: 'view_dashboard' },
                ]
              }
            }
          ]
        },
        {
          id: 'crm',
          title: 'crm_title',
          icon: 'bi bi-people-fill',
          color: '#10b981',
          colorDark: '#059669',
          items: [
            {
              clients: {
                permissions: [
                  { key: 'create_clients', label: 'create_clients' },
                  { key: 'edit_clients', label: 'edit_clients' },
                  { key: 'view_clients', label: 'view_clients' },
                  { key: 'delete_clients', label: 'delete_clients' }
                ]
              }
            },
            {
              suppliers: {
                permissions: [
                  { key: 'create_suppliers', label: 'create_suppliers' },
                  { key: 'edit_suppliers', label: 'edit_suppliers' },
                  { key: 'view_suppliers', label: 'view_suppliers' },
                  { key: 'delete_suppliers', label: 'delete_suppliers' }
                ]
              }
            }
          ]
        },
        {
          id: 'inventory',
          title: 'inventory_title',
          icon: 'bi bi-box-seam',
          color: '#f59e0b',
          colorDark: '#d97706',
          items: [
            {
              products: {
                permissions: [
                  { key: 'create_inventories', label: 'create_inventories' },
                  { key: 'edit_inventories', label: 'edit_inventories' },
                  { key: 'view_inventories', label: 'view_inventories' },
                  { key: 'delete_inventories', label: 'delete_inventories' }
                ]
              }
            },
            {
              categories: {
                permissions: [
                  { key: 'create_categories', label: 'create_categories' },
                  { key: 'edit_categories', label: 'edit_categories' },
                  { key: 'view_categories', label: 'view_categories' },
                  { key: 'delete_categories', label: 'delete_categories' }
                ]
              }
            },
            {
              warehouses: {
                permissions: [
                  { key: 'create_warehouses', label: 'create_warehouses' },
                  { key: 'edit_warehouses', label: 'edit_warehouses' },
                  { key: 'view_warehouses', label: 'view_warehouses' },
                  { key: 'delete_warehouses', label: 'delete_warehouses' }
                ]
              }
            }
          ]
        },
        {
          id: 'sales',
          title: 'sales_title',
          icon: 'bi bi-cart-check-fill',
          color: '#3b82f6',
          colorDark: '#2563eb',
          items: [
            {
              quote: {
                permissions: [
                  { key: 'create_quote', label: 'create_quote' },
                  { key: 'edit_quote', label: 'edit_quote' },
                  { key: 'view_quotes', label: 'view_quotes' },
                  { key: 'delete_quote', label: 'delete_quote' }
                ]
              }
            },
            {
              orders: {
                permissions: [
                  { key: 'create_orders', label: 'create_orders' },
                  { key: 'edit_orders', label: 'edit_orders' },
                  { key: 'view_orders', label: 'view_orders' },
                  { key: 'delete_orders', label: 'delete_orders' }
                ]
              }
            },
            {
              deliveries: {
                permissions: [
                  { key: 'create_deliveries', label: 'create_deliveries' },
                  { key: 'edit_deliveries', label: 'edit_deliveries' },
                  { key: 'view_deliveries', label: 'view_deliveries' },
                  { key: 'delete_deliveries', label: 'delete_deliveries' }
                ]
              }
            },
            {
              invoices: {
                permissions: [
                  { key: 'create_invoices', label: 'create_invoices' },
                  { key: 'edit_invoices', label: 'edit_invoices' },
                  { key: 'view_invoices', label: 'view_invoices' },
                  { key: 'delete_invoices', label: 'delete_invoices' }
                ]
              }
            },
            {
              processes: {
                permissions: [
                  { key: 'create_receipts', label: 'create_receipts' },
                  { key: 'edit_receipts', label: 'edit_receipts' },
                  { key: 'view_receipts', label: 'view_receipts' },
                  { key: 'delete_receipts', label: 'delete_receipts' }
                ]
              }
            },
            {
              returns: {
                permissions: [
                  { key: 'create_returns', label: 'create_returns' },
                  { key: 'edit_returns', label: 'edit_returns' },
                  { key: 'view_returns', label: 'view_returns' },
                  { key: 'delete_returns', label: 'delete_returns' }
                ]
              }
            }
          ]
        },
        {
          id: 'purchases',
          title: 'purchasing_title',
          icon: 'bi bi-bag-check-fill',
          color: '#8b5cf6',
          colorDark: '#7c3aed',
          items: [
            {
              purchases: {
                permissions: [
                  { key: 'create_purchases', label: 'create_purchases' },
                  { key: 'edit_purchases', label: 'edit_purchases' },
                  { key: 'view_purchases', label: 'view_purchases' },
                  { key: 'delete_purchases', label: 'delete_purchases' }
                ]
              }
            },
            {
              receptions: {
                permissions: [
                  { key: 'create_receptions', label: 'create_receptions' },
                  { key: 'edit_receptions', label: 'edit_receptions' },
                  { key: 'view_receptions', label: 'view_receptions' },
                  { key: 'delete_receptions', label: 'delete_receptions' }
                ]
              }
            },
            {
              "supplier_invoices": {
                permissions: [
                  { key: 'create_supplier_invoices', label: 'create_supplier_invoices' },
                  { key: 'edit_supplier_invoices', label: 'edit_supplier_invoices' },
                  { key: 'view_supplier_invoices', label: 'view_supplier_invoices' },
                  { key: 'delete_supplier_invoices', label: 'delete_supplier_invoices' }
                ]
              }
            },
            {
              "supplier_returns": {
                permissions: [
                  { key: 'create_supplier_returns', label: 'create_supplier_returns' },
                  { key: 'edit_supplier_returns', label: 'edit_supplier_returns' },
                  { key: 'view_supplier_returns', label: 'view_supplier_returns' },
                  { key: 'delete_supplier_returns', label: 'delete_supplier_returns' }
                ]
              }
            }
          ]
        },
        {
          id: 'pos',
          title: 'pos_title',
          icon: 'bi bi-cash-stack',
          color: '#ec4899',
          colorDark: '#db2777',
          items: [
            {
              pos: {
                permissions: [
                  { key: 'create_pos', label: 'create_pos' },
                  { key: 'view_pos', label: 'view_pos' },
                ]
              }
            },
            {
              "transaction": {
                permissions: [
                  { key: 'view_pos_transactions', label: 'view_pos_transactions' },
                  { key: 'delete_pos_transactions', label: 'delete_pos_transactions' }
                ]
              }
            },
            {
              "cash_register": {
                permissions: [
                  { key: 'view_pos_cash_registers', label: 'view_pos_cash_registers' },
                ]
              }
            },
            {
              "pos_insights": {
                permissions: [
                  { key: 'view_pos_insights', label: 'pos_insights' },
                ]
              }
            },
          ]
        },
        {
          id: 'finance',
          title: 'finance_title',
          icon: 'bi bi-wallet2',
          color: '#14b8a6',
          colorDark: '#0d9488',
          items: [
            {
              payments: {
                permissions: [
                  { key: 'create_payments', label: 'create_payments' },
                  { key: 'view_payments', label: 'view_payments' },
                  { key: 'delete_payments', label: 'delete_payments' }
                ]
              }
            }
          ]
        },
        {
          id: 'hr',
          title: 'hr_management',
          icon: 'bi bi-person-badge-fill',
          color: '#db2777',
          colorDark: '#be185d',
          items: [
            {
              my_space: {
                permissions: [
                  { key: 'view_my_space', label: 'view_my_space' }
                ]
              }
            },
            {
              employees: {
                permissions: [
                  { key: 'create_employees', label: 'create_employees' },
                  { key: 'edit_employees', label: 'edit_employees' },
                  { key: 'view_employees', label: 'view_employees' },
                  { key: 'delete_employees', label: 'delete_employees' }
                ]
              }
            },
            {
              payrolls: {
                permissions: [
                  { key: 'create_payrolls', label: 'create_payrolls' },
                  { key: 'edit_payrolls', label: 'edit_payrolls' },
                  { key: 'view_payrolls', label: 'view_payrolls' },
                  { key: 'delete_payrolls', label: 'delete_payrolls' }
                ]
              }
            },
            {
              holidays: {
                permissions: [
                  { key: 'create_holidays', label: 'create_holidays' },
                  { key: 'edit_holidays', label: 'edit_holidays' },
                  { key: 'view_holidays', label: 'view_holidays' },
                  { key: 'delete_holidays', label: 'delete_holidays' }
                ]
              }
            },
            {
              attendances: {
                permissions: [
                  { key: 'create_attendances', label: 'create_attendances' },
                  { key: 'edit_attendances', label: 'edit_attendances' },
                  { key: 'view_attendances', label: 'view_attendances' },
                  { key: 'delete_attendances', label: 'delete_attendances' }
                ]
              }
            },
            {
              hr_insights: {
                permissions: [
                  { key: 'view_hr_insights', label: 'view_hr_insights' }
                ]
              }
            }
          ]
        },
        {
          id: 'planning',
          title: 'planning',
          icon: 'bi bi-calendar-check',
          color: '#8b5cf6',
          colorDark: '#7c3aed',
          items: [
            {
              plannings: {
                permissions: [
                  { key: 'create_plannings', label: 'create_plannings' },
                  { key: 'edit_plannings', label: 'edit_plannings' },
                  { key: 'view_plannings', label: 'view_plannings' },
                  { key: 'delete_plannings', label: 'delete_plannings' }
                ]
              }
            },
            {
              my_planning: {
                permissions: [
                  { key: 'view_my_planning', label: 'view_my_planning' }
                ]
              }
            }
          ]
        },
        {
          id: 'leads',
          title: 'leads_title',
          icon: 'bi bi-person-lines-fill',
          color: '#0ea5e9',
          colorDark: '#0284c7',
          items: [
            {
              leads: {
                permissions: [
                  { key: 'create_leads', label: 'create_leads' },
                  { key: 'edit_leads', label: 'edit_leads' },
                  { key: 'view_leads', label: 'view_leads' },
                  { key: 'delete_leads', label: 'delete_leads' }
                ]
              }
            }
          ]
        },
        {
          id: 'marketing',
          title: 'marketing_title',
          icon: 'bi bi-megaphone',
          color: '#6366f1',
          colorDark: '#4f46e5',
          items: [
            {
              marketing: {
                permissions: [
                  { key: 'view_marketing', label: 'view_marketing' },
                  { key: 'manage_marketing', label: 'manage_marketing' }
                ]
              }
            }
          ]
        },
        {
          id: 'contracts',
          title: 'contracts',
          icon: 'bi bi-file-earmark-text-fill',
          color: '#0891b2',
          colorDark: '#0e7490',
          items: [
            {
              contracts: {
                permissions: [
                  { key: 'create_contracts', label: 'create_contracts' },
                  { key: 'edit_contracts', label: 'edit_contracts' },
                  { key: 'view_contracts', label: 'view_contracts' },
                  { key: 'delete_contracts', label: 'delete_contracts' }
                ]
              }
            }
          ]
        },
        {
          id: 'attachments',
          title: 'attachments_title',
          icon: 'bi bi-paperclip',
          color: '#64748b',
          colorDark: '#475569',
          items: [
            {
              attachments: {
                permissions: [
                  { key: 'create_attachments', label: 'create_attachments' },
                  { key: 'edit_attachments', label: 'edit_attachments' },
                  { key: 'view_attachments', label: 'view_attachments' },
                  { key: 'delete_attachments', label: 'delete_attachments' }
                ]
              }
            }
          ]
        },
        {
          // Keep this aligned with the module_key in the Vuex module registry.
          // The plural value prevented this card from appearing for enabled
          // accountant modules and from being resolved in the users table.
          id: 'accountant',
          title: 'accountant',
          icon: 'bi bi-calculator',
          color: '#84cc16',
          colorDark: '#65a30d',
          items: [
            {
              accountants: {
                permissions: [
                  { key: 'view_accountants', label: 'view_accountant' }
                ]
              }
            }
          ]
        },
        {
          id: 'project_management',
          title: 'project_management',
          icon: 'bi bi-kanban',
          color: '#f97316',
          colorDark: '#ea580c',
          items: [
            {
              projects: {
                permissions: [
                  { key: 'create_projects', label: 'create_projects' },
                  { key: 'edit_projects', label: 'edit_projects' },
                  { key: 'view_projects', label: 'view_projects' },
                  { key: 'delete_projects', label: 'delete_projects' }
                ]
              }
            },
            {
              tasks: {
                permissions: [
                  { key: 'create_tasks', label: 'create_tasks' },
                  { key: 'edit_tasks', label: 'edit_tasks' },
                  { key: 'view_tasks', label: 'view_tasks' },
                  { key: 'delete_tasks', label: 'delete_tasks' }
                ]
              }
            }
          ]
        },
        // {
        //   id: 'settings',
        //   title: 'settings_title',
        //   items: [
        //     {
        //       settings: {
        //         permissions: [
        //           { key: 'view_settings', label: 'view_settings' },
        //           { key: 'edit_settings', label: 'edit_settings' },
        //         ]
        //       }
        //     },
        //     // {
        //     //   users: {
        //     //     permissions: [
        //     //       { key: 'create_users', label: 'create_users' },
        //     //       { key: 'edit_users', label: 'edit_users' },
        //     //       { key: 'view_users', label: 'view_users' },
        //     //       { key: 'delete_users', label: 'delete_users' }
        //     //     ]
        //     //   }
        //     // },
        //     // {
        //     //   roles: {
        //     //     permissions: [
        //     //       { key: 'create_roles', label: 'create_roles' },
        //     //       { key: 'edit_roles', label: 'edit_roles' },
        //     //       { key: 'view_roles', label: 'view_roles' },
        //     //       { key: 'delete_roles', label: 'delete_roles' }
        //     //     ]
        //     //   }
        //     // }
        //   ]
        // }
      ],
      permissionsState: {}
    }
  },
  mounted(){
    window.mixpanel.track("user");

    //check permissions
    if(helper.checkAccess('manage_business') == -1) return this.$router.push({path : '/'})
    if(helper.checkAccess('manage_business') == -2) return this.$router.push({path : '/subscribe'})

    this.getUsers()

    // eslint-disable-next-line no-undef
    this.createModal = new bootstrap.Modal(document.getElementById('user-create-modal'),{backdrop: 'static', keyboard: false})
    
    // eslint-disable-next-line no-undef
    this.editModal = new bootstrap.Modal(document.getElementById('user-edit-modal'),{backdrop: 'static', keyboard: false})

    // Initialize permissionsState
    this.initializePermissionsState();
  },
  methods : {
    sortUsers(field) {
      this.toggleSort(field)
      this.getUsers(false)
    },
    create(){
        this.clearForm()
        // eslint-disable-next-line no-undef
        this.createModal.show()
    },
    edit(row){
        this.user = row 
        if(row.UserBusiness && row.UserBusiness.role){
          this.user.role = row.UserBusiness.role
        }

        if(row.UserBusiness && row.UserBusiness.permissions){
          this.user.permissions = row.UserBusiness.permissions
        }

        const newState = { ...this.permissionsState };
        this.permissionsModules.forEach(module => {
            module.items.forEach(item => {
                Object.values(item).forEach(subModule => {
                    subModule.permissions.forEach(permission => {
                        newState[permission.key] = row.permissions?.includes(permission.key) || false;
                    });
                });
            });
        });
        this.permissionsState = newState;

        this.editModal.show()
    },
    async save(){
        try{
            this.loading = true
            const permissions = this.user.role !== 'owner'
              ? Object.keys(this.permissionsState).filter(key => this.permissionsState[key])
              : [];
            await helper.customPost(`${process.env.VUE_APP_API}/users`,{...this.user,permissions},{showToast:true})
            this.loading = false
            this.getUsers()
            this.clearForm()
            this.createModal.hide()
        }catch(error){
            this.loading = false
        }

    },
    async update(){
        try{
            this.loading = true
            const permissions = this.user.role !== 'owner'
              ? Object.keys(this.permissionsState).filter(key => this.permissionsState[key])
              : [];
            await helper.customPatch(`${process.env.VUE_APP_API}/users/${this.user.id}`,{...this.user, permissions})
            this.loading = false
            this.clearForm()
            this.editModal.hide()
            this.getUsers()
        }catch(error){
            this.loading = false
        }

    },
    async deleteRow(row){
        this.$swal.fire({
        title: `${this.$t('are_you_sure')}?`,
        text : this.$t('you_cant_revert'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes_delete_it')
        }).then(async (result) => {
            if (result.isConfirmed) {
                await helper.customDelete(`${process.env.VUE_APP_API}/users/${row.id}`)
                this.users = helper.withoutDeletedRecords(this.users, row.id)
                this.count = Math.max(0, this.count - 1)
            }
        })
    },
    clearForm(){
        this.user = {
            id : null,
            name : '',
            email : '',
            phone : '',
            address : '',
            password : '',
            notes : '',
            role : 'staff'
        }
        const newState = { ...this.permissionsState };
        Object.keys(newState).forEach(key => {
            newState[key] = false;
        });
        this.permissionsState = newState;
    },
    async getUsers(loadMore){
        try{
            this.loading = true
            this.page = loadMore ? this.page+1 : 1
            this.users = this.page == 1 ? [] : this.users
            const params = new URLSearchParams({ page: this.page })
            this.appendSortParams(params)
            const response = await helper.customGet(`${process.env.VUE_APP_API}/users?${params.toString()}`)
            this.users = this.users.length ? [...this.users, ...response.data.data] :  response.data.data
            this.count = response.data.count 
            this.loading = false 
        }catch(error){
            this.loading = false 
        }

    },
    goDetails(id){
        this.$router.push({path: `/users/${id}`, params : { id }});
    },
    SelectUserRole(e){
        this.user = {...this.user, role : e.target.value}
        this.user.update = !this.user.update
    },
    //helper functions
    formatDate(date) { return helper.formatDate(date) },
    shortId(id) { return helper.shortId(id) },
    isOwnerUser(row) {
      return row?.UserBusiness?.role === 'owner'
    },
    getUserModules(row) {
      const role = row?.UserBusiness?.role
      if (role === 'owner') {
        return this.enabledModules
      }

      const userPermissions = row?.UserBusiness?.permissions || []
      return this.enabledModules.filter(module => {
        return this.getModulePermissionKeys(module).some(permission => userPermissions.includes(permission))
      })
    },
    getVisibleUserModules(row) {
      return this.getUserModules(row).slice(0, 3)
    },
    hasHiddenUserModules(row) {
      return this.getUserModules(row).length > 3
    },
    getModulePermissionKeys(module) {
      const modulePermissions = (module.items || [])
        .map(item => item.permission)
        .filter(Boolean)

      const permissionModule = this.permissionsModules.find(permissionGroup => permissionGroup.id === module.module_key)
      if (!permissionModule) {
        return modulePermissions
      }

      permissionModule.items.forEach(item => {
        Object.values(item).forEach(subModule => {
          subModule.permissions.forEach(permission => {
            if (!modulePermissions.includes(permission.key)) {
              modulePermissions.push(permission.key)
            }
          })
        })
      })

      return modulePermissions
    },
    initializePermissionsState() {
      const newState = {};
      this.permissionsModules.forEach(module => {
        module.items.forEach(item => {
          Object.values(item).forEach(subModule => {
            subModule.permissions.forEach(permission => {
              newState[permission.key] = false;
            });
          });
        });
      });
      this.permissionsState = newState;
    },
    selectAllPermissions() {
      const newState = { ...this.permissionsState };
      Object.keys(newState).forEach(key => {
        newState[key] = true;
      });
      this.permissionsState = newState;
    },
    deselectAllPermissions() {
      const newState = { ...this.permissionsState };
      Object.keys(newState).forEach(key => {
        newState[key] = false;
      });
      this.permissionsState = newState;
    },
    toggleModulePermissions(module) {
      const allSelected = this.isModuleFullySelected(module);
      module.items.forEach(item => {
        Object.values(item).forEach(subModule => {
          subModule.permissions.forEach(permission => {
            this.$set(this.permissionsState, permission.key, !allSelected);
          });
        });
      });
    },
    toggleSubModulePermissions(subModule) {
      const allSelected = subModule.permissions.every(p => this.permissionsState[p.key]);
      subModule.permissions.forEach(permission => {
        this.$set(this.permissionsState, permission.key, !allSelected);
      });
    },
    isModuleFullySelected(module) {
      return module.items.every(item => 
        Object.values(item).every(subModule => 
          subModule.permissions.every(p => this.permissionsState[p.key])
        )
      );
    },
    isSubModuleManaged(subModule) {
      return subModule.permissions.some(p => this.permissionsState[p.key]);
    },
    toggleManageSubModule(subModule, event) {
      const isChecked = event.target.checked;
      subModule.permissions.forEach(permission => {
        this.$set(this.permissionsState, permission.key, isChecked);
      });
    }
  },
  watch : {
    async search(){
        if(this.search.length > 2){
            try{
                this.loading = true
                const response = await helper.customPost(`${process.env.VUE_APP_API}/users/search`,{keyword : this.search})
                this.users = response.data.data
                this.loading = false
            }catch(error){
                this.loading = false
            }

        }
        if(this.search == '') return this.getUsers()
    }
  },
  computed : {
    role(){ return this.$store.getters.ROLE },
    permissions(){ return this.$store.getters.PERMISSIONS },
    business(){ return this.$store.getters.BUSINESS },
    modules(){ return this.$store.getters.MODULES },
    enabledModules() {
      return (this.modules || []).filter(module => module.enabled && module.module_key !== 'settings')
    },
    filteredPermissionsModules() {
      if(!this.modules) return this.permissionsModules
      return this.permissionsModules.filter(module => {
        const storeModule = this.modules.find(m => m.module_key === module.id)
        return storeModule ? storeModule.enabled : false
      })
    }
  }
}
</script>
<style scoped>
    .table-borderless>:not(caption)>*>*{
        padding: 5px !important
    }
    
    .hover-shadow {
        transition: all 0.3s ease;
    }
    
    .hover-shadow:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;
    }
    
    .btn-toggle-module {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        opacity: 0.9;
    }
    
    .btn-toggle-module:hover {
        opacity: 1;
    }
    
    .form-check-input:checked {
        background-color: #004aad;
        border-color: #004aad;
    }
    
    .card-header {
        border-bottom: none;
    }

    .user-module-badges {
        display: flex;
        flex-wrap: wrap;
        gap: 0.35rem;
        min-width: 13rem;
    }

    .user-row-actions {
        display: flex;
        align-items: center;
        gap: 0.1rem;
    }

    .user-row-action {
        margin: 0;
        padding: 5px;
        font-size: 12px !important;
    }

    .user-module-badge {
        background: #eef2ff;
        border: 1px solid #c7d2fe;
        border-radius: 6px;
        color: #3730a3;
        font-size: 0.72rem;
        font-weight: 600;
        letter-spacing: 0;
        padding: 0.35rem 0.5rem;
    }

    .user-module-more {
        min-width: 1.7rem;
        text-align: center;
    }
</style>
